import { defineStore } from "pinia";
import { ref } from "vue";
import { ClausulasConfirmacionApi, ClausulasConfirmacionProcesosApi } from "@/api";
import { useUIStateStore, useNotificacionStore } from ".";

export const useClausulasConfirmacionStore = defineStore(
  "clausulasConfirmacion",
  () => {
    const uiState = useUIStateStore();

    const clausulasConfirmacion = ref([]);
    const catServicioId = ref(0);
    const isInitizalized = ref(false);

    async function initializeStore(cat_servicio_id) {
      catServicioId.value = cat_servicio_id;
      await fetchClausulasConfirmacion();
    }

    async function fetchClausulasConfirmacion() {
      if (!isInitizalized.value) {
        uiState.startLoading();
        const { value } = await ClausulasConfirmacionApi.list({
          page: 0,
          registersPerPage: 0,
          catServicioId: catServicioId.value,
        });
        uiState.stopLoading();

        clausulasConfirmacion.value = value;
        isInitizalized.value = true;
      }
    }

    async function fetchClausulasConfirmacionCatServicioId(cat_servicio_id) {
      uiState.startLoading();
      const { value } = await ClausulasConfirmacionApi.list({
        page: 0,
        registersPerPage: 0,
        catServicioId: cat_servicio_id,
      });
      uiState.stopLoading();

      return value;
    }

    async function fetchClausulasConfirmacionProceso(cat_servicio_id, proceso_id) {
      uiState.startLoading();
      const { value } = await ClausulasConfirmacionProcesosApi.list({
        page: 0,
        registersPerPage: 0,
        catServicioId: cat_servicio_id,
        procesoId: v,
      });
      uiState.stopLoading();

      return value;
    }

    function getClausulasConfirmacion(currentComponent) {
      if (catServicioId.value === 2) {
        if (currentComponent === "Ubicacion") {
          return clausulasConfirmacion.value.filter((c) => [1].includes(c.id));
        } else if (currentComponent === "Cotizacion") {
          const arr = [2, 4, 5, 6];
          const notificacion = useNotificacionStore();

          if (!notificacion.fad) {
            arr.push(3);
          }

          return clausulasConfirmacion.value.filter((c) => arr.includes(c.id));
        }
      }
    }

    function setClausulaConfirmacion(clausulaId, value) {
      if (catServicioId.value === 2) {
        const notificacion = useNotificacionStore();
        const clausulaConfirmacionExistente = notificacion.clausulas_confirmacion.find(
          (c) => c.clausula_confirmacion_id === clausulaId,
        );

        if (clausulaConfirmacionExistente) {
          clausulaConfirmacionExistente.confirmado = value;
        } else {
          notificacion.clausulas_confirmacion.push({
            clausula_confirmacion_id: clausulaId,
            cat_servicio_id: 2,
            confirmado: value,
          });
        }
      }
    }

    return {
      clausulasConfirmacion,
      initializeStore,
      getClausulasConfirmacion,
      setClausulaConfirmacion,
      fetchClausulasConfirmacionCatServicioId,
      fetchClausulasConfirmacionProceso,
    };
  },
  {
    persist: false,
  },
);
